import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ChargingOutputApiResponse,
  ChargingOutputsApiResponse,
  ChargingOutputResponse,
  createUserChargingOutput,
  getUserSpecificChargingOutput,
} from "./chargingOutputAction";

interface ChargingOutputState {
  chargingOutput: ChargingOutputResponse | null;
  chargingOutputs: ChargingOutputResponse[];
  total: number;
  page: number;
  pages: number;
  loading: boolean;
  error: string | null;
}

const initialState: ChargingOutputState = {
  chargingOutput: null,
  chargingOutputs: [],
  total: 0,
  page: 1,
  pages: 1,
  loading: false,
  error: null,
};

const chargingOutputSlice = createSlice({
  name: "chargingOutput",
  initialState,
  reducers: {
    resetChargingOutputState: (state) => {
      state.chargingOutput = null;
      state.chargingOutputs = [];
      state.total = 0;
      state.page = 1;
      state.pages = 1;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle createUserChargingOutput
      .addCase(createUserChargingOutput.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        createUserChargingOutput.fulfilled,
        (state, action: PayloadAction<ChargingOutputApiResponse>) => {
          state.loading = false;
          state.chargingOutput = action.payload.data?.chargingOutput || null;
          state.error = null;
        }
      )
      .addCase(
        createUserChargingOutput.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.loading = false;
          state.error = action.payload || "Failed to create charging output";
        }
      )
      // Handle getUserSpecificChargingOutput
      .addCase(getUserSpecificChargingOutput.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getUserSpecificChargingOutput.fulfilled,
        (state, action: PayloadAction<ChargingOutputsApiResponse>) => {
          state.loading = false;
          state.chargingOutputs = action.payload.data?.chargingOutputs || [];
          state.total = action.payload.data?.total || 0;
          state.page = action.payload.data?.page || 1;
          state.pages = action.payload.data?.pages || 1;
          state.error = null;
        }
      )
      .addCase(
        getUserSpecificChargingOutput.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.loading = false;
          state.error = action.payload || "Failed to retrieve charging outputs";
        }
      );
  },
});

export const { resetChargingOutputState } = chargingOutputSlice.actions;
export default chargingOutputSlice.reducer;
